import React from 'react';

function Iraq(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124096)">
        <mask
          id="mask0_800_124096"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124096)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124096"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124096)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#BF2714"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.0037 12.8112C7.02701 14.1166 5.625 15 5.625 15C5.625 15 6.85068 15 7.32009 14.1256H17.3521V12.1998C17.3521 12.1998 17.1423 11.275 16.249 11.275C15.3557 11.275 15.1544 12.1998 15.1544 12.1998H11.6259L15.0399 9.52087L14.3761 9L10.584 11.9756V12.6065H15.9673V12.2351C15.9673 12.2351 15.9975 12.0201 16.249 12.0201C16.5005 12.0201 16.4393 12.2351 16.4393 12.2351V13.0284H9.65544V11.9437L8.92089 12.2351V13.0284C8.92089 13.0284 8.02126 12.8112 7.45274 12.8112C6.88422 12.8112 6.85068 12.2351 6.85068 12.2351L6.0037 12.8112ZM19.6274 12.8853L20.1775 14.1031H17.9883V9.21438L18.9118 9.47713V12.8853H19.6274ZM29.8249 12.8853L30.375 14.1031H28.1858V9.21438L29.1093 9.47713V12.8853H29.8249ZM27.1142 9.26496L26.5438 9.60815V12.8819H25.9627V10.2563L25.0056 10.7468V12.8819H24.3632V11.3995L23.6356 11.8158V12.2182C23.6356 12.2182 22.2361 12.304 22.2361 14.0628H27.1086L27.1142 9.26496ZM8.42823 14.9656C8.60422 14.9656 8.7469 14.8537 8.7469 14.7156C8.7469 14.5775 8.60422 14.4655 8.42823 14.4655C8.25223 14.4655 8.10956 14.5775 8.10956 14.7156C8.10956 14.8537 8.25223 14.9656 8.42823 14.9656ZM24.6538 9.64166C24.4064 9.93158 23.6555 9.64166 23.6555 9.64166L25.7847 9.42239C25.5648 9.80398 24.6538 9.64166 24.6538 9.64166Z"
              fill="#009C4E"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124096">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Iraq;
